import React, { Component } from 'react';

//Import Component
import NavBar from "../components/NavBar";
import GeneralInfoForm from "../components/GeneralInfoForm";
import Footer from "../components/Footer";

class GeneralInfo extends Component {
  state = { 
    usename: '',
    success: false,
    registered: false,
  }

  componentDidMount() {
    this.setState({ 
      username: localStorage.getItem('username'),
      success: localStorage.getItem('success'),
      registered: localStorage.getItem('registered')
    });

    if (window.scrollY) {
      window.scroll(0, 0);  // reset the scroll position to the top left of the document.
    }
  }

  render() {
    return (
        <>
            {/* NavBar: src/components/NavBar.jsx */}
            <NavBar 
              pageName="home" 
              username={this.state.username} 
              success={this.state.success} 
              registered={this.state.registered}
            />

            {/* BlogPost: src/components/Blog/BlogPost.jsx */}
            <GeneralInfoForm />

            {/* Footer: src/components/Footer.jsx */}
            <Footer />
        </>
    );
  }
}
export default GeneralInfo;
